import * as types from "./types";
import { updateObject } from "../utility";
import { getItem } from "../../Auth/localStorageService";
import { languageKey } from "../../components/LanguageSelector/LanguageSelectorConstant";

const getBrowserLanguage = () => {
  if (typeof navigator === "undefined") return languageKey.en;
  const lang = navigator.language || "";
  return lang.startsWith("es") ? languageKey.sp : languageKey.en;
};

const initialState = {
  language: getItem("language") || getBrowserLanguage(),
  version: 0,
};
const setLanguageChange = (state, action) => {
  return updateObject(state, {
    language: action.payload,
    version: state.version + 1,
  });
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE:
      return setLanguageChange(state, action);
    default:
      return state;
  }
};
export default languageReducer;
